module.exports = __webpack_public_path__ + "static/media/archway.da042780.svg";